import StockItem from "./StockItem";
export default StockItem;